import "./Projects.css";

import Sidebar from "./components/sidebar/Sidebar";
import Categories from "./components/categories/Categories";
import { ICategory } from "../../interfaces/category.interface";
import { useCallback, useEffect, useState } from "react";
import { getProjectCategories, getProjects } from "../../services/firestore.service";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { fetched } from "../../slices/projectsSlice";

interface ProjectsProps {
    clearSelectedProject: () => void;
}

const Projects = ({ clearSelectedProject }: ProjectsProps): React.JSX.Element => {
    const [categories, setCategories] = useState<ICategory[] | null>(null);

    const projectsDispatch = useAppDispatch();
    const currentProject = useAppSelector((state) => state.projects.currentProject);

    const updateCategories = useCallback((): void => {
        setCategories(null);
        getProjectCategories(currentProject.id).then((cs) => setCategories(cs));
    }, [currentProject?.id]);

    const fetchProjects = (): void => {
        getProjects().then((ps) => {
            projectsDispatch(fetched(ps));
        });
    };

    useEffect(() => {
        fetchProjects();
    });

    return (
        <div className="projects-container">
            <Sidebar updateProjects={fetchProjects} />
            {!currentProject ? (
                <div>Select a project</div>
            ) : (
                <Categories
                    categories={categories}
                    updateProjects={fetchProjects}
                    updateCategories={updateCategories}
                    clearSelectedProject={clearSelectedProject}
                />
            )}
        </div>
    );
};

export default Projects;
